module.exports = __webpack_public_path__ + "img/Namibia.16d27b05.svg";